export default "__VITE_ASSET__3f132e4e__"